module.exports = __webpack_public_path__ + "static/img/89048D_20171016_R_2_3_4_LC.5b6b7e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/89048D_20171016_R_2_3_4_LC.png
// module id = i+IQ
// module chunks = 0